import { useState } from "react";
import { subscribe } from "../lib/api";
import { trackEvent } from "../lib/analytics";
import { Arrow } from "./Icons";

/**
 * Reusable email capture.
 * props: tags (array|null), consent (string), buttonLabel, idPrefix (testids),
 *        eventName (analytics), tyBody (thank-you copy)
 */
export const JoinForm = ({
  tags = null,
  consent,
  buttonLabel = "Join Dialed In",
  idPrefix = "join",
  eventName = "join_signup",
  tyBody = "Welcome to the build. Keep an eye on your inbox — and if anything rings true, hit reply. Jason reads every one.",
}) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const [emailBad, setEmailBad] = useState(false);

  const submit = async () => {
    setErr("");
    if (!email.trim() || !email.includes("@")) {
      setEmailBad(true);
      setTimeout(() => setEmailBad(false), 2200);
      return;
    }
    setBusy(true);
    try {
      const payload = { first_name: name.trim(), email: email.trim() };
      if (tags) payload.tags = tags;
      await subscribe(payload);
      trackEvent(eventName, { tags: (tags || ["getdialedin"]).join(",") });
      setDone(true);
    } catch (e) {
      const detail = e?.response?.data?.detail;
      setErr(typeof detail === "string" ? detail : "Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  const onKey = (e) => { if (e.key === "Enter") submit(); };

  if (done) {
    return (
      <div className="ty-block" data-testid={`${idPrefix}-thankyou`}>
        <h3 className="ty-head">You're in.</h3>
        <p className="ty-body">{tyBody}</p>
      </div>
    );
  }

  return (
    <div>
      <input
        type="text"
        className="field"
        placeholder="First name"
        autoComplete="given-name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={onKey}
        data-testid={`${idPrefix}-first-name`}
      />
      <input
        type="email"
        className={`field${emailBad ? " field-err" : ""}`}
        placeholder="Email address"
        autoComplete="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={onKey}
        data-testid={`${idPrefix}-email`}
      />
      <div className="submit-row">
        <button className="cta" onClick={submit} disabled={busy} data-testid={`${idPrefix}-submit-btn`}>
          {busy ? "Sending" : buttonLabel}
          <Arrow />
        </button>
      </div>
      <p className={`form-fine${err ? " err" : ""}`} data-testid={`${idPrefix}-fine`}>
        {err || consent}
      </p>
    </div>
  );
};
